import { Component } from '@angular/core';
import { AppNavigationHeaderComponent } from '../../../components/navigation-header/app-navigation-header.component';
import { ClientListTableComponent } from '../client-list-table/client-list-table.component';
import { BreadcrumbLabelDirective } from '../../../directives/breadcrumb-label.directive';

@Component({
	selector: 'app-client-main-tab',
	templateUrl: './client-main-tab.component.html',
	styleUrls: ['./client-main-tab.component.scss'],
	imports: [
		AppNavigationHeaderComponent,
		ClientListTableComponent,
		BreadcrumbLabelDirective,
	],
})
export class ClientMainTabComponent {
	clientListBreadcrumbLabel = $localize`:@@clientMainTab-clientListBreadcrumbLabel:Clients`;
	constructor() {}
}
